<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div>
    <!-- <header class="home-header wrap" :class="{ active: headerScroll }">
      <router-link tag="i" to="./category"
        ><i class="nbicon nbmenu2"></i
      ></router-link>
      <div class="header-search">
        <span class="app-name">油途商城</span>
      </div>
      <router-link class="login" tag="span" to="./login" v-if="!isLogin"
        >登录</router-link
      >
      <router-link class="login" tag="span" to="./user" v-else>
        <van-icon name="manager-o" />
      </router-link>
    </header> -->
    <nav-bar />
    <div class="content">
      <div class="swiper-warp">
        <!-- <div class="swiper-text">
          <span>服务保障</span>
          <span>服务保障</span>
          <span>服务保障</span>
          <span>服务保障</span>
        </div> -->
        <div class="swiper-search">
          <router-link
            tag="span"
            class="search-title"
            to="./product-list?from=home"
            ><van-icon name="search" />请输入查找内容</router-link
          >
        </div>
        <div class="swiper-text">
          <!-- <span @click="handleIcbc">工行支付测试：</span> -->
          <span>热门搜索：</span>
          <span>焚烧合同</span>
          <span>废铅酸蓄电池</span>
          <span>废机油</span>
        </div>

        <swiper :list="swiperList"></swiper>
      </div>
      <div class="category-warp">
        <div class="category-list">
          <div
            v-for="item in categoryList"
            v-bind:key="item.categoryId"
            @click="tips(item.categoryId)"
          >
            <img :src="item.image" />
            <span>{{ item.categoryName }}</span>
          </div>
          <div @click="tips(categoryList[0].categoryId)">
            <img src="../assets/gd.png" />
            <span>更多</span>
          </div>
        </div>
      </div>
      <div class="good-warp">
        <div class="good">
          <div class="discount">
            <img :src="discountImg" alt="" @click="goDiscount" />
          </div>
        </div>
        <div class="good" :style="{ paddingBottom: '55px' }">
          <header class="good-header">商品推荐</header>
          <van-skeleton title :row="3" :loading="loading">
            <div class="good-box">
              <div
                class="good-item"
                v-for="item in recommends"
                :key="item.goodsId"
              >
                <div class="goot-imgwarp">
                  <img
                    :src="$filters.prefix(item.goodsCoverImg)"
                    alt=""
                    @click="goToDetail(item)"
                  />
                </div>
                <div class="good-desc">
                  <div class="title" @click="goToDetail(item)">
                    {{ item.goodsName }}
                  </div>
                  <div class="price">
                    <div>
                      ¥<span style="font-size: 18px"
                        >{{ item.sellingPrice }}&nbsp;</span
                      >
                    </div>
                    <div style="font-size: 12px; color: #999999">
                      {{ item.purchases }}人加购
                    </div>
                  </div>
                  <!-- <div class="addprodct" @click="addprodct(item)"></div> -->
                </div>
              </div>
            </div>
          </van-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { addCart } from '@/service/cart'

import swiper from '@/components/Swiper'
import navBar from '@/components/NavBar'
import { getHome } from '@/service/home'
import { getCategoryall } from '@/service/good'
import { loginJava, getListtoken } from '@/service/user'
import { setLocal } from '@/common/js/utils'

import { getLocal } from '@/common/js/utils'
import { Toast } from 'vant'
export default {
  name: 'home',
  components: {
    swiper,
    navBar
  },
  setup() {
    const store = useStore()
    const route = useRoute()

    const router = useRouter()
    const state = reactive({
      swiperList: [], // 轮播图列表
      isLogin: false, // 是否已登录
      headerScroll: true, // 滚动透明判断
      hots: [], //热门商品
      newGoodses: [], //新品上线
      recommends: [], //品牌推荐
      discountImg: require('../assets/discount.png'), //优惠卷图片
      categoryList: [
        {
          name: '废机油',
          imgUrl: require('../assets/fjy.png'),
          categoryId: 3
        },
        {
          name: '危废焚烧',
          imgUrl: require('../assets/wffs.png'),
          categoryId: 5
        },
        {
          name: '废电池',
          imgUrl: require('../assets/fdc.png'),
          categoryId: 4
        },
        {
          name: '应急预案',
          imgUrl: require('../assets/yjya.png'),
          categoryId: 18
        },
        {
          name: '运输备案',
          imgUrl: require('../assets/ysba.png'),
          categoryId: 18
        },
        {
          name: '排污/水证',
          imgUrl: require('../assets/pw.png'),
          categoryId: 18
        },
        {
          name: '三废检测',
          imgUrl: require('../assets/sfjc.png'),
          categoryId: 24
        },
        {
          name: '更多',
          imgUrl: require('../assets/gd.png'),
          categoryId: 3
        }
      ],
      loading: true
    })

    const init = () => {
      //获取url参数，进行storage 存储准备
      const {
        account,
        key,
        province,
        city,
        county,
        companyName,
        contractStatus
      } = route.query
      const obj = {
        user: account,
        pwd: key,
        province,
        city,
        county,
        companyName,
        contractStatus
      }
      setLocal('userData', JSON.stringify(obj)) // 将参数进行storage 存储

      const urlQuery = route.query.account
      const tokenValue = getLocal('token')
      const phoneNum = getLocal('phoneNum')

      if (urlQuery) {
        // URL有值的时候,才会走自动登录
        if (phoneNum && phoneNum !== urlQuery) {
          // 有缓存手机号 并且 和新手机号码不一样,重新自动登录
          autoLogin()
        } else {
          if (tokenValue) {
            //有token的时候先调用java接口判断当前token是否过期
            checkToken()
          } else {
            //
            autoLogin()
          }
        }
      }

      // if (urlQuery) {
      //   if (tokenValue) {
      //     //有token的时候先调用java接口判断当前token是否过期
      //     checkToken()
      //   }

      //   const phoneNum = getLocal('phoneNum')
      //   if (phoneNum !== urlQuery) {
      //     //获取本地存储手机号与url带过来的手机号不一致 ,自动登录
      //     autoLogin()
      //   }
      // }
    }

    //自动登录
    async function autoLogin() {
      console.log('执行自动登录fun...')
      const urlQuery = route.query.account
      const {
        account,
        key,
        province,
        city,
        county,
        companyName,
        contractStatus,
        isThorough
      } = route.query
      await loginJava({
        loginName: account,
        passwordMd5: key,
        province: province,
        city: city,
        county: county,
        nickName: companyName,
        contractStatus: contractStatus,
        isThorough: isThorough
      }).then(async (res) => {
        setLocal('token', res.data)
        setLocal('phoneNum', urlQuery)
        // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置
        // window.location.href = '/'
        window.location.reload()
      })
    }

    // 核验token 是否过期，过期则走自动登录
    async function checkToken() {
      const getToken = getLocal('token')
      const { companyName, contractStatus } = route.query
      const { res } = await getListtoken({
        token: getToken,
        contractStatus: contractStatus,
        nickName: companyName
      }).catch((err) => {
        if (err.resultCode == 500) {
          console.log('token过期了，走重新自动登录!')
          autoLogin()
        }
      })
      console.log(res)
      console.log('--------------')
    }

    onMounted(async () => {
      init()

      const token = getLocal('token')
      if (token) {
        state.isLogin = true
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      //导航
      await getCategoryall().then((res) => {
        state.categoryList = res.data.slice(0, 7)
      })

      const { data } = await getHome()
      state.swiperList = data.carousels
      state.newGoodses = data.newGoodses
      state.hots = data.hotGoodses
      state.recommends = data.recommendGoodses
      state.loading = false
      Toast.clear()
    })

    // nextTick(() => {
    //   window.addEventListener('scroll', () => {
    //     let scrollTop =
    //       window.pageYOffset ||
    //       document.documentElement.scrollTop ||
    //       document.body.scrollTop
    //     scrollTop > 100
    //       ? (state.headerScroll = true)
    //       : (state.headerScroll = false)
    //   })
    // })

    const goToDetail = (item) => {
      router.push({ path: `/product/${item.goodsId}` })
    }

    const goDiscount = () => {
      router.push({ path: '/Discount' })
    }
    const tips = (categoryId) => {
      router.push({ path: '/category', query: { categoryId: categoryId } })
    }

    const gpt = () => {
      window.open('https://gpt.oiltour.cn/')
    }

    const addprodct = async (item) => {
      await addCart({
        goodsCount: 1,
        goodsId: item.goodsId,
        goodsSkuId: item.goodsSkuId
      }).then((res) => {
        if (res.resultCode === 200) {
          Toast.success('加购成功')
        }
      })
      store.dispatch('updateCart')
    }
    /* const handleIcbc = ()=>{

      router.push({ 
        path: '/transfer',
        query: {
          paySign: '%7B%22timeStamp%22%3A%221685092555%22%2C%22package%22%3A%22prepay_id%3Dwx261715553964653a7618ef672bbaf30000%22%2C%22paySign%22%3A%22vWTbj3789oaDSkPP9L6ZrSk2q7voTXWqKRrCobdhUCalMQ7iZdQEUMBihNGu%2F6cB%2F9JypnoD%2BIfFUurh7QyLgyVxDCdMB%2FB0WBz3Wo8Rm%2FvRDmC3eMc4vefyy0QBam31ob5fOszkms5qKzsY2sc8E1FSGWRAWZObADXfNvcR7eNDrze1zmOMDEjiOh8hh0aJwaMeH%2FgFxQFE24wQl58W7iR6P%2BRs57JQAxLFByq3xvUn4Mt57eeiaOEgCjtehbco%2FjjZt4EHuve1CjMPyxTnC8OWPy8CHBZ%2B235UHKNVV63G0tOZFO8jfLzyesigeeC5B8R5fDuxSOIWFb7xyCGKIQ%3D%3D%22%2C%22appId%22%3A%22wx9715dadf976e5b1c%22%2C%22signType%22%3A%22RSA%22%2C%22nonceStr%22%3A%22b06b641a0bdf4d3aa4af5b759e678a55%22%7D'
        }
        // url: '/transfer?paySign=%7B%22timeStamp%22%3A%221684995018%22%2C%22package%22%3A%22prepay_id%3Dwx25141018582730e30e144d3f2c7c5a0000%22%2C%22paySign%22%3A%22SMVNmXkYQ%2F5oyjKkv%2FBj7z5UA8zwWzUAsLnmH05qaIJor4O2FgZGimgkD%2BCd67mQnpX1qhSZ0sUmQjh3Uj1a9Z46YBYxmMTkZLrbuvxVvMFRqRzUusay%2B%2Fjbwmji1F7aeq3ZlJs5IQ5%2BOggM%2Bc8oMugeShnk9Zabw%2F3Xy66YB2QJNOVsQxrQc%2FIT2kv%2BsR%2FN1zuv2gT%2BLuvPUbMidWmgQg6lmoYUps%2FseX1JHm1uX0YazrJ0Glj6eSN7UPgWslZCeYeeqSxYlMMVsSIRMR0rV%2BqEzIXYiVAK7XvAakDGm0NmKHldUfAUc%2Fa6oeqBve%2BryEpMFUf7KM1CZGTM1CW2uw%3D%3D%22%2C%22appId%22%3A%22wx9715dadf976e5b1c%22%2C%22signType%22%3A%22RSA%22%2C%22nonceStr%22%3A%22ydCJ9nsG06Emv12UyNPuXYmHdhfE1ozR%22%7D'
      })
      console.log('ccc...');
    } */
    return {
      ...toRefs(state),
      goToDetail,
      tips,
      addprodct,
      goDiscount,
      gpt
    }
  }
}
</script>

<style lang="less" scoped >
@import '../common/style/mixin';
.content {
  background: #ffffff;
}
.swiper-warp {
  padding: 15px 15px 15px 15px;
  background-color: 40c4ff; /* 浏览器不支持的时候显示 */
  background-image: linear-gradient(180deg, #40c6ff, #40c4ff, #ffffff, #ffffff);
  color: #fff;
  .swiper-text {
    margin: 10px 0 10px 0;
    color: #ffffff;
    span {
      margin: 0 5px;
    }
  }
}
.search-title {
  i {
    font-size: 18px;
    position: relative;
    top: 4px;
    right: 2px;
  }
  display: block;
  background: #fff;
  font-size: 13px;
  color: #999999;
  line-height: 38px;
  height: 35px;
  border-radius: 20px;
  text-align: left;
  padding: 0 10px;
}
.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 50px);
  .fj();
  line-height: 50px;
  padding: 0 15px;
  .boxSizing();
  font-size: 15px;
  color: #fff;
  z-index: 10000;
  .nbmenu2 {
    color: @primary;
  }
  &.active {
    background: @primary;
    .nbmenu2 {
      color: #fff;
    }
    .login {
      color: #fff;
    }
  }

  .header-search {
    display: flex;
    line-height: 25px;
    margin: 10px 0;
    padding: 5px 0;
    color: #232326;
    .app-name {
      padding: 0 10px;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
  }
  .icon-iconyonghu {
    color: #fff;
    font-size: 22px;
  }
  .login {
    color: @primary;
    line-height: 52px;
    .van-icon-manager-o {
      font-size: 20px;
      vertical-align: -3px;
    }
  }
}
.category-list {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  width: 100%;
  color: #333333;
  div {
    display: flex;
    flex-direction: column;
    width: 25%;
    text-align: center;
    img {
      .wh(50px, 50px);
      margin: 13px auto 8px auto;
    }
  }
}
.good {
  .good-header {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    padding: 0 15px;
    text-align: left;
    color: #585b58;
    font-size: 16px;
  }
  .discount {
    padding: 20px 10px 20px 10px;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .good-box {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .good-item {
      box-shadow: 0 2px 5px #e7e7e7;
      box-sizing: border-box;
      width: 45%;
      margin: 5px 2.5%;
      background: #fff;
      border: none;
      padding: 10px 10px;
      border-radius: 10px;
      .goot-imgwarp {
        width: 100%;
        height: 120px;
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        img {
          display: block;
          width: 100%;
          margin: 0 auto;
        }
      }
      .good-desc {
        position: relative;
        text-align: center;
        font-size: 14px;
        padding: 10px 0 0 0;
        .title {
          color: #333333;
          text-align: left;
        }
        .price {
          // text-align: left;
          display: flex;
          justify-content: space-between;
          color: red;
          font-weight: bold;
          margin: 5px 0;
          font-size: 12px;
        }
        .explain {
          text-align: left;
          font-size: 12px;
          color: #222333;
        }
        .addprodct {
          position: absolute;
          bottom: 0px;
          right: 0px;
          border-radius: 100%;
          width: 15px;
          height: 15px;
          background: url('../assets/add.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
.floor-list {
  width: 100%;
  padding-bottom: 50px;
  .floor-head {
    width: 100%;
    height: 40px;
    background: #f6f6f6;
  }
  .floor-content {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    width: 100%;
    .boxSizing();
    .floor-category {
      width: 50%;
      padding: 10px;
      border-right: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
      .boxSizing();
      &:nth-child(2n) {
        border-right: none;
      }
      p {
        font-size: 17px;
        color: #333;
        &:nth-child(2) {
          padding: 5px 0;
          font-size: 13px;
          color: @primary;
        }
      }
      .floor-products {
        .fj();
        width: 100%;
        img {
          .wh(65px, 65px);
        }
      }
    }
  }
}
</style>